import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/creators/{creatorSlug}/ui';

export type CreatorUiApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

export const useCreatorUi = (
  { creatorSlug }: CreatorUiApi['params'],
  config?: UseNoodleSwrConfig<CreatorUiApi['response']>,
): SWRResponse<CreatorUiApi['response'], ApiError> => {
  const path = buildPath<CreatorUiApi>(PATH_TEMPLATE, { creatorSlug });
  return useNoodleSwr(path, { revalidateOnFocus: false, ...config });
};

const getCreatorUI = async ({ creatorSlug }: CreatorUiApi['params']): Promise<CreatorUiApi['response']> => {
  const path = buildPath<CreatorUiApi>(PATH_TEMPLATE, { creatorSlug });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getCreatorUI;
